import { NgForm } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';

@Component({
  selector: 'app-attach-trailer',
  templateUrl: './attach-trailer.component.html',
  styleUrls: ['./attach-trailer.component.scss']
})
export class AttachTrailerComponent implements OnInit {

  stepperModel: AttachDetachStepperModel;

  @ViewChild('attachTrailerForm', { static: true }) attachTrailerForm: NgForm;

  constructor(
    public translationService: TranslationService,
    private stepperService: TransportAttachDetachStepperService
  ) {
    this.stepperModel = this.stepperService.stepperModel;
    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      if (!this.attachTrailerForm) {
        return false;
      }
      return this.attachTrailerForm.valid;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {
  }

}
